import {useCallback} from 'react';
import {useModalControls} from '@chekinapp/ui';
import {useStepperStore, useIVStore} from '@chekin/shared';
import {discardIVScan} from '@/hooks/iv/ivLockStore';

function useDiscardIVModal() {
  const {resetAllIVState} = useIVStore();
  const {resetIVProcess} = useStepperStore();

  const {
    isOpen: isOpenDiscardIVModal,
    closeModal: closeDiscardIVModal,
    openModal: openDiscardIVModal,
  } = useModalControls();

  const resetAllIVStates = useCallback(() => {
    resetIVProcess();
    resetAllIVState();
    discardIVScan();
    closeDiscardIVModal();
  }, [resetIVProcess, resetAllIVState, closeDiscardIVModal]);

  return {
    isOpenDiscardIVModal,
    closeDiscardIVModal,
    openDiscardIVModal,
    resetIVProcess: resetAllIVStates,
  };
}

export {useDiscardIVModal};
